import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/lti';
import * as ltiPageActions from '../actions/lti';
import { Log } from 'ng2-logger';
import { LtiService } from '../../api/lti-page-services';
import Translator from '../../core/i18n';
import { Notification } from '../../components/notification/main';
import * as coreActions from '../actions/core';
import { param } from 'jquery';
const T = Translator.create();
const _logger = Log.create('LTI Saga');
const _ltiService = new LtiService();

//#region "Add Lti Activity Saga"
function* setAddLtiActivity(params: any): any {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
         yield _ltiService
            .RequestAddLtiActivityAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(null);
            }
        }
        if (!isError) {
            yield put(
                coreActions.newNotification(
                    params.ltiData && params.ltiData.isUpdate
                        ? T.t('r_update_activity_succesful_notification')
                        : T.t('r_add_activity_succesful_notification'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
            const redirectPageParams: any = {
                submitValues: params.ltiData,
                activityId: params.ltiData.projectActivityId
                    ? params.ltiData.projectActivityId
                    : params.ltiData.activityId
                        ? params.ltiData.activityId
                        : pageData,
                termWeekId:
                    params.ltiData.termWeekIds && params.ltiData.termWeekIds[0] !== '0'
                        ? params.ltiData.termWeekIds[0]
                        : params.ltiData.termWeekIds[1]
            };
            if (params.callback) {
            params.callback(redirectPageParams);
            }
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        if (params.callback) {
            params.callback(null);
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

// update lti data!!!
function* setLtiActivity(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield put(ltiPageActions.addLtiSetAction(null));
        const pageData = yield _ltiService
            .RequestGetLtiAsync({ ...params, take: 20, skip: 0 })
            .then((response: Response) => {
                return response;
            })
            .then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            })
            .then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    return responseData;
                }
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });

        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');

            return false;
        } else {
            yield put(ltiPageActions.addLtiSetAction(pageData, params.spinnerId, 'set'));
            return true;
        }
    } catch (error) {
        Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');
        return false;
    }
}

function* setDeleteLtiActivity(params: any): any {
    try {
        const pageData = yield _ltiService
            .RequestDeleteLtiActivityAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });

        yield put(ltiPageActions.addLtiSetAction(null));
    } catch (error) {
        Notification.setNotification('error', T.t('r_document_activity_pdf_viewing_error_message'), 'topRight');
    }
}

function* launchLti(params: any): any {
    try {
        const pageData = yield _ltiService
            .RequestLaunchLtiAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    var form = document.createElement('form');
                    data.fields.forEach((element: any) => {
                        var elements = document.createElement('input');

                        elements.value = element.value;
                        elements.name = element.key;
                        elements.type = 'hidden';
                        form.appendChild(elements);
                    });

                    var signatureElement = document.createElement('input');
                    signatureElement.value = data.signature;
                    signatureElement.name = 'oauth_signature';
                    signatureElement.type = 'hidden';
                    form.appendChild(signatureElement);

                    form.method = 'POST';
                    form.action = data.formAction;
                    form.target = '_blank';
                    document.body.appendChild(form);

                    form.submit();

                    return data;
                }
            });

        yield put(ltiPageActions.addLtiSetAction(null));
    } catch (error) {
        Notification.setNotification('error', T.t('r_document_activity_pdf_viewing_error_message'), 'topRight');
    }
}

export function* watchGetAddltiData() {
    yield takeEvery(constants.actions.ADD_LTI_ACTIVITY, setAddLtiActivity);
    return null;
}

export function* watchGetDeleteltiData() {
    yield takeEvery(constants.actions.DELETE_LTI_ACTIVITY, setDeleteLtiActivity);
    return null;
}

export function* watchUpdateltiData() {
    yield takeEvery(constants.actions.ADD_LTI_UPDATE_ACTIVITY, setLtiActivity);
    return null;
}

export function* watchLaunchLti() {
    yield takeEvery(constants.actions.LAUNCH_LTI, launchLti);
    return null;
}

//#endregion "Add Lti Activity End Saga"

export function* LtiSagas() {
    yield all([watchGetAddltiData(), watchGetDeleteltiData(), watchUpdateltiData(), watchLaunchLti()]);
}
